module.exports = [
    {
        base: 'arise',
        past: 'arose',
        participle: 'arisen',
        fr: 'survenir, se produire',
    },
    {
        base: 'awake',
        past: 'awoke',
        participle: 'awoken',
        fr: '(se) réveiller',
    },
    {
        base: 'bear',
        past: 'bore',
        participle: 'borne',
        fr: 'supporter / porter / naître',
    },
    {
        base: 'beat',
        past: 'beat',
        participle: 'beaten',
        fr: 'battre',
    },
    {
        base: 'become',
        past: 'became',
        participle: 'become',
        fr: 'devenir',
    },
    {
        base: 'begin',
        past: 'began',
        participle: 'begun',
        fr: 'commencer',
    },
    {
        base: 'bend',
        past: 'bent',
        participle: 'bent',
        fr: 'plier, se courber',
    },
    {
        base: 'bet',
        past: 'bet',
        participle: 'bet',
        fr: 'parier',
    },
    {
        base: 'bid',
        past: 'bid',
        participle: 'bid',
        fr: 'offrir un prix, enchérir',
    },
    {
        base: 'bind',
        past: 'bound',
        participle: 'bound',
        fr: 'lier, relier',
    },
    {
        base: 'bite',
        past: 'bit',
        participle: 'bitten',
        fr: 'mordre',
    },
    {
        base: 'bleed',
        past: 'bled',
        participle: 'bled',
        fr: 'saigner',
    },
    {
        base: 'blow',
        past: 'blew',
        participle: 'blown',
        fr: 'souffler',
    },
    {
        base: 'break',
        past: 'broke',
        participle: 'broken',
        fr: 'casser',
    },
    {
        base: 'breed',
        past: 'bred',
        participle: 'bred',
        fr: 'élever (des animaux)',
    },
    {
        base: 'bring',
        past: 'brought',
        participle: 'brought',
        fr: 'apporter',
    },
    {
        base: 'build',
        past: 'built',
        participle: 'built',
        fr: 'construire',
    },
    {
        base: 'burn',
        past: 'burnt',
        participle: 'burnt',
        fr: 'brûler',
    },
    {
        base: 'burst',
        past: 'burst',
        participle: 'burst',
        fr: 'éclater',
    },
    {
        base: 'buy',
        past: 'bought',
        participle: 'bought',
        fr: 'acheter',
    },
    {
        base: 'cast',
        past: 'cast',
        participle: 'cast',
        fr: 'jeter (un sort), donner un rôle',
    },
    {
        base: 'catch',
        past: 'caught',
        participle: 'caught',
        fr: 'attraper',
    },
    {
        base: 'choose',
        past: 'chose',
        participle: 'chosen',
        fr: 'choisir',
    },
    {
        base: 'cling',
        past: 'clung',
        participle: 'clung',
        fr: 's’accrocher, adhérer (coller)',
    },
    {
        base: 'come',
        past: 'came',
        participle: 'come',
        fr: 'venir',
    },
    {
        base: 'cost',
        past: 'cost',
        participle: 'cost',
        fr: 'coûter',
    },
    {
        base: 'creep',
        past: 'crept',
        participle: 'crept',
        fr: 'ramper, grimper',
    },
    {
        base: 'cut',
        past: 'cut',
        participle: 'cut',
        fr: 'couper',
    },
    {
        base: 'daydream',
        past: 'daydreamt',
        participle: 'daydreamt',
        fr: 'rêvasser',
    },
    {
        base: 'deal',
        past: 'dealt',
        participle: 'dealt',
        fr: 'distribuer',
    },
    {
        base: 'dig',
        past: 'dug',
        participle: 'dug',
        fr: 'creuser',
    },
    {
        base: 'dive',
        past: 'dived',
        participle: 'dived',
        fr: 'plonger',
    },
    {
        base: 'do',
        past: 'did',
        participle: 'done',
        fr: 'faire',
    },
    {
        base: 'draw',
        past: 'drew',
        participle: 'drawn',
        fr: 'dessiner',
    },
    {
        base: 'dream',
        past: 'dreamt',
        participle: 'dreamt',
        fr: 'rêver',
    },
    {
        base: 'drink',
        past: 'drank',
        participle: 'drunk',
        fr: 'boire',
    },
    {
        base: 'drive',
        past: 'drove',
        participle: 'driven',
        fr: 'conduire',
    },
    {
        base: 'dwell',
        past: 'dwelt',
        participle: 'dwelt',
        fr: 'habiter',
    },
    {
        base: 'eat',
        past: 'ate',
        participle: 'eaten',
        fr: 'manger',
    },
    {
        base: 'fall',
        past: 'fell',
        participle: 'fallen',
        fr: 'tomber',
    },
    {
        base: 'feed',
        past: 'fed',
        participle: 'fed',
        fr: 'nourrir',
    },
    {
        base: 'feel',
        past: 'felt',
        participle: 'felt',
        fr: 'sentir, éprouver',
    },
    {
        base: 'fight',
        past: 'fought',
        participle: 'fought',
        fr: 'se battre, combattre',
    },
    {
        base: 'find',
        past: 'found',
        participle: 'found',
        fr: 'trouver',
    },
    {
        base: 'flee',
        past: 'fled',
        participle: 'fled',
        fr: 's’enfuir',
    },
    {
        base: 'fling',
        past: 'flung',
        participle: 'flung',
        fr: 'jeter violemment',
    },
    {
        base: 'fly',
        past: 'flew',
        participle: 'flown',
        fr: 'voler (avion)',
    },
    {
        base: 'forbid',
        past: 'forbade',
        participle: 'forbidden',
        fr: 'interdire',
    },
    {
        base: 'forecast',
        past: 'forecast',
        participle: 'forecast',
        fr: 'prévoir (un événement, la météo)',
    },
    {
        base: 'forget',
        past: 'forgot',
        participle: 'forgotten',
        fr: 'oublier',
    },
    {
        base: 'forgive',
        past: 'forgave',
        participle: 'forgiven',
        fr: 'pardonner',
    },
    {
        base: 'forsake',
        past: 'forsook',
        participle: 'forsaken',
        fr: 'abandonner',
    },
    {
        base: 'freeze',
        past: 'froze',
        participle: 'frozen',
        fr: 'geler',
    },
    {
        base: 'get',
        past: 'got',
        participle: 'got',
        fr: 'obtenir',
    },
    {
        base: 'give',
        past: 'gave',
        participle: 'given',
        fr: 'donner',
    },
    {
        base: 'go',
        past: 'went',
        participle: 'gone',
        fr: 'aller',
    },
    {
        base: 'grind',
        past: 'ground',
        participle: 'ground',
        fr: 'moudre / broyer',
    },
    {
        base: 'grow',
        past: 'grew',
        participle: 'grown',
        fr: 'grandir',
    },
    {
        base: 'hang',
        past: 'hung',
        participle: 'hung',
        fr: 'pendre, tenir, accrocher',
    },
    {
        base: 'have',
        past: 'had',
        participle: 'had',
        fr: 'avoir',
    },
    {
        base: 'hear',
        past: 'heard',
        participle: 'heard',
        fr: 'entendre',
    },
    {
        base: 'hide',
        past: 'hid',
        participle: 'hidden',
        fr: '(se) cacher',
    },
    {
        base: 'hit',
        past: 'hit',
        participle: 'hit',
        fr: 'frapper, atteindre, toucher (de façon violente)',
    },
    {
        base: 'hold',
        past: 'held',
        participle: 'held',
        fr: 'tenir',
    },
    {
        base: 'hurt',
        past: 'hurt',
        participle: 'hurt',
        fr: 'blesser',
    },
    {
        base: 'keep',
        past: 'kept',
        participle: 'kept',
        fr: 'garder',
    },
    {
        base: 'kneel',
        past: 'knelt',
        participle: 'knelt',
        fr: 's’agenouiller',
    },
    {
        base: 'know',
        past: 'knew',
        participle: 'known',
        fr: 'savoir, connaître',
    },
    {
        base: 'lay',
        past: 'laid',
        participle: 'laid',
        fr: 'poser à plat',
    },
    {
        base: 'lead',
        past: 'led',
        participle: 'led',
        fr: 'mener',
    },
    {
        base: 'lean',
        past: 'leant',
        participle: 'leant',
        fr: 's’appuyer',
    },
    {
        base: 'leap',
        past: 'leapt',
        participle: 'leapt',
        fr: 'bondir',
    },
    {
        base: 'learn',
        past: 'learnt',
        participle: 'learnt',
        fr: 'apprendre',
    },
    {
        base: 'leave',
        past: 'left',
        participle: 'left',
        fr: 'laisser, quitter',
    },
    {
        base: 'lend',
        past: 'lent',
        participle: 'lent',
        fr: 'prêter',
    },
    {
        base: 'let',
        past: 'let',
        participle: 'let',
        fr: 'permettre',
    },
    {
        base: 'lie',
        past: 'lay',
        participle: 'lain',
        fr: 'être couché, reposer (signifie aussi mentir)',
    },
    {
        base: 'light',
        past: 'lit',
        participle: 'lit',
        fr: 'allumer',
    },
    {
        base: 'lose',
        past: 'lost',
        participle: 'lost',
        fr: 'perdre',
    },
    {
        base: 'make',
        past: 'made',
        participle: 'made',
        fr: 'fabriquer, faire',
    },
    {
        base: 'mean',
        past: 'meant',
        participle: 'meant',
        fr: 'signifier, vouloir dire',
    },
    {
        base: 'meet',
        past: 'met',
        participle: 'met',
        fr: '(se) rencontrer',
    },
    {
        base: 'melt',
        past: 'melted',
        participle: 'melted',
        fr: 'fondre',
    },
    {
        base: 'mishear',
        past: 'misheard',
        participle: 'misheard',
        fr: 'mal entendre',
    },
    {
        base: 'misunderstand',
        past: 'misunderstood',
        participle: 'misunderstood',
        fr: 'mal comprendre',
    },
    {
        base: 'mow',
        past: 'mowed',
        participle: 'mown',
        fr: 'tondre',
    },
    {
        base: 'overcome',
        past: 'overcame',
        participle: 'overcome',
        fr: 'surmonter, vaincre',
    },
    {
        base: 'overbid',
        past: 'overbid',
        participle: 'overbid',
        fr: 'surenchérir',
    },
    {
        base: 'overlay',
        past: 'overlaid',
        participle: 'overlaid',
        fr: 'superposer',
    },
    {
        base: 'overthrow',
        past: 'overthrew',
        participle: 'overthrown',
        fr: 'renverser (un gouvernement, président…)',
    },
    {
        base: 'pay',
        past: 'paid',
        participle: 'paid',
        fr: 'payer',
    },
    {
        base: 'plead',
        past: 'pleaded',
        participle: 'pleaded',
        fr: 'supplier / plaider',
    },
    {
        base: 'proofread',
        past: 'proofread',
        participle: 'proofread',
        fr: 'relire / corriger les fautes d’un texte',
    },
    {
        base: 'prove',
        past: 'proved',
        participle: 'proved',
        fr: 'prouver',
    },
    {
        base: 'put',
        past: 'put',
        participle: 'put',
        fr: 'mettre',
    },
    {
        base: 'quit',
        past: 'quit',
        participle: 'quit',
        fr: 'cesser (de)',
    },
    {
        base: 'read',
        past: 'read',
        participle: 'read',
        fr: 'lire',
    },
    {
        base: 'rid',
        past: 'rid',
        participle: 'rid',
        fr: 'débarrasser',
    },
    {
        base: 'ride',
        past: 'rode',
        participle: 'ridden',
        fr: 'chevaucher',
    },
    {
        base: 'ring',
        past: 'rang',
        participle: 'rung',
        fr: 'sonner',
    },
    {
        base: 'rise',
        past: 'rose',
        participle: 'risen',
        fr: 's’élever, se lever',
    },
    {
        base: 'run',
        past: 'ran',
        participle: 'run',
        fr: 'courir',
    },
    {
        base: 'saw',
        past: 'sawed',
        participle: 'sawn',
        fr: 'scier',
    },
    {
        base: 'say',
        past: 'said',
        participle: 'said',
        fr: 'dire',
    },
    {
        base: 'see',
        past: 'saw',
        participle: 'seen',
        fr: 'voir',
    },
    {
        base: 'seek',
        past: 'sought',
        participle: 'sought',
        fr: 'chercher',
    },
    {
        base: 'sell',
        past: 'sold',
        participle: 'sold',
        fr: 'vendre',
    },
    {
        base: 'send',
        past: 'sent',
        participle: 'sent',
        fr: 'envoyer',
    },
    {
        base: 'set',
        past: 'set',
        participle: 'set',
        fr: 'fixer',
    },
    {
        base: 'sew',
        past: 'sewed',
        participle: 'sewn',
        fr: 'coudre',
    },
    {
        base: 'shake',
        past: 'shook',
        participle: 'shaken',
        fr: 'secouer',
    },
    {
        base: 'shear',
        past: 'sheared',
        participle: 'shorn',
        fr: 'tondre (des moutons)',
    },
    {
        base: 'shed',
        past: 'shed',
        participle: 'shed',
        fr: 'mettre en lumière / verser du sang',
    },
    {
        base: 'shine',
        past: 'shone',
        participle: 'shone',
        fr: 'briller',
    },
    {
        base: 'shoot',
        past: 'shot',
        participle: 'shot',
        fr: 'tirer / tuer par balle / filmer (tourner un film)',
    },
    {
        base: 'show',
        past: 'showed',
        participle: 'shown',
        fr: 'montrer',
    },
    {
        base: 'shrink',
        past: 'shrank',
        participle: 'shrunk',
        fr: 'rétrécir',
    },
    {
        base: 'shut',
        past: 'shut',
        participle: 'shut',
        fr: 'fermer',
    },
    {
        base: 'sing',
        past: 'sang',
        participle: 'sung',
        fr: 'chanter',
    },
    {
        base: 'sink',
        past: 'sank',
        participle: 'sunk',
        fr: 'couler (un bateau…)',
    },
    {
        base: 'sit',
        past: 'sat',
        participle: 'sat',
        fr: 'être assis',
    },
    {
        base: 'sleep',
        past: 'slept',
        participle: 'slept',
        fr: 'dormir',
    },
    {
        base: 'slide',
        past: 'slid',
        participle: 'slid',
        fr: 'glisser',
    },
    {
        base: 'slink',
        past: 'slunk',
        participle: 'slunk',
        fr: 'lancer (avec force)',
    },
    {
        base: 'slit',
        past: 'slit',
        participle: 'slit',
        fr: 'fendre, inciser',
    },
    {
        base: 'smell',
        past: 'smelt',
        participle: 'smelt',
        fr: 'sentir (odorat) / flairer',
    },
    {
        base: 'sow',
        past: 'sowed',
        participle: 'sown',
        fr: 'semer (des graines)',
    },
    {
        base: 'speak',
        past: 'spoke',
        participle: 'spoken',
        fr: 'parler',
    },
    {
        base: 'speed',
        past: 'sped',
        participle: 'sped',
        fr: 'accélérer',
    },
    {
        base: 'spell',
        past: 'spelt',
        participle: 'spelt',
        fr: 'épeler',
    },
    {
        base: 'spend',
        past: 'spent',
        participle: 'spent',
        fr: 'dépenser',
    },
    {
        base: 'spill',
        past: 'spilt',
        participle: 'spilt',
        fr: 'renverser (un liquide)',
    },
    {
        base: 'spit',
        past: 'spat',
        participle: 'spat',
        fr: 'cracher',
    },
    {
        base: 'split',
        past: 'split',
        participle: 'split',
        fr: 'fendre',
    },
    {
        base: 'spoil',
        past: 'spoilt',
        participle: 'spoilt',
        fr: 'gâcher',
    },
    {
        base: 'spread',
        past: 'spread',
        participle: 'spread',
        fr: 'répandre',
    },
    {
        base: 'spring',
        past: 'sprang',
        participle: 'sprung',
        fr: 'jaillir, bondir',
    },
    {
        base: 'stand',
        past: 'stood',
        participle: 'stood',
        fr: 'être debout',
    },
    {
        base: 'steal',
        past: 'stole',
        participle: 'stolen',
        fr: 'voler quelque chose, dérober',
    },
    {
        base: 'stick',
        past: 'stuck',
        participle: 'stuck',
        fr: 'coller',
    },
    {
        base: 'sting',
        past: 'stung',
        participle: 'stung',
        fr: 'piquer',
    },
    {
        base: 'stink',
        past: 'stank',
        participle: 'stunk',
        fr: 'puer',
    },
    {
        base: 'stride',
        past: 'strode',
        participle: 'stridden',
        fr: 'marcher à grand pas',
    },
    {
        base: 'strike',
        past: 'struck',
        participle: 'struck',
        fr: 'frapper',
    },
    {
        base: 'string',
        past: 'strung',
        participle: 'strung',
        fr: 'enfiler, tendre (une corde)',
    },
    {
        base: 'strive',
        past: 'strove',
        participle: 'striven',
        fr: 's’efforcer',
    },
    {
        base: 'swear',
        past: 'swore',
        participle: 'sworn',
        fr: 'jurer',
    },
    {
        base: 'sweep',
        past: 'swept',
        participle: 'swept',
        fr: 'balayer',
    },
    {
        base: 'swell',
        past: 'swelled',
        participle: 'swollen',
        fr: 'enfler',
    },
    {
        base: 'swim',
        past: 'swam',
        participle: 'swum',
        fr: 'nager',
    },
    {
        base: 'swing',
        past: 'swung',
        participle: 'swung',
        fr: 'se balancer',
    },
    {
        base: 'take',
        past: 'took',
        participle: 'taken',
        fr: 'prendre',
    },
    {
        base: 'teach',
        past: 'taught',
        participle: 'taught',
        fr: 'enseigner',
    },
    {
        base: 'tear',
        past: 'tore',
        participle: 'torn',
        fr: 'déchirer',
    },
    {
        base: 'tell',
        past: 'told',
        participle: 'told',
        fr: 'dire, raconter',
    },
    {
        base: 'think',
        past: 'thought',
        participle: 'thought',
        fr: 'penser',
    },
    {
        base: 'throw',
        past: 'threw',
        participle: 'thrown',
        fr: 'jeter',
    },
    {
        base: 'thrust',
        past: 'thrust',
        participle: 'thrust',
        fr: 'enfoncer',
    },
    {
        base: 'tread',
        past: 'trod',
        participle: 'trodden',
        fr: 'fouler aux pieds',
    },
    {
        base: 'undergo',
        past: 'underwent',
        participle: 'undergone',
        fr: 'subir',
    },
    {
        base: 'understand',
        past: 'understood',
        participle: 'understood',
        fr: 'comprendre',
    },
    {
        base: 'upset',
        past: 'upset',
        participle: 'upset',
        fr: 'bouleverser',
    },
    {
        base: 'wake',
        past: 'woke',
        participle: 'woken',
        fr: '(se) réveiller',
    },
    {
        base: 'wear',
        past: 'wore',
        participle: 'worn',
        fr: 'porter (des vêtements)',
    },
    {
        base: 'weave',
        past: 'wove',
        participle: 'woven',
        fr: 'tisser',
    },
    {
        base: 'weep',
        past: 'wept',
        participle: 'wept',
        fr: 'pleurnicher',
    },
    {
        base: 'wet',
        past: 'wet',
        participle: 'wet',
        fr: 'mouiller',
    },
    {
        base: 'win',
        past: 'won',
        participle: 'won',
        fr: 'gagner',
    },
    {
        base: 'wind',
        past: 'wound',
        participle: 'wound',
        fr: 'enrouler',
    },
    {
        base: 'withdraw',
        past: 'withdrew',
        participle: 'withdrawn',
        fr: '(se) retirer, retirer de l’argent',
    },
    {
        base: 'wring',
        past: 'wrung',
        participle: 'wrung',
        fr: 'tordre',
    },
    {
        base: 'write',
        past: 'wrote',
        participle: 'written',
        fr: 'écrire',
    },
];
